@if (tags(); as tags) { @if (tags.length) {
<!-- -->
@if (mode () === 'stacked') {
<!-- -->
@for (tag of tags; track tag.text; let first =$first) {
<div [class.push-top-sm]="!first">
	<lib-tag
		[isFullSize]="true"
		[tagType]="tag.tagType ?? 'basic'"
		[isClickable]="tag.click ? true : false"
		(click)="handleClick(tag)"
	>
		<div libFlexRow [libFlexRowAlign]="'center'" [libFlexRowGap]="'6px'">
			@if (tag.icon){
			<div libFlexColumn class="tag-icon"><lib-icon [type]="tag.icon" [size]="'small'"></lib-icon></div>
			}
			<div libFlexColumn>
				<div libLineClamp [clampLines]="1">
					{{ tag.text }}
				</div>
			</div>
		</div>
	</lib-tag>
</div>
} } @else {
<div [libFlexRow]="true" [libFlexRowGap]="'8px'">
	@for (tag of tags; track tag.text) {
	<div libFlexColumn>
		<lib-tag [tagType]="tag.tagType ?? 'basic'" [isClickable]="tag.click ? true : false" (click)="handleClick(tag)">
			<div libFlexRow [libFlexRowAlign]="'center'" [libFlexRowGap]="'6px'">
				@if (tag.icon){
				<div libFlexColumn class="tag-icon"><lib-icon [type]="tag.icon" [size]="'small'"></lib-icon></div>
				}
				<div libFlexColumn>{{ tag.text }}</div>
			</div>
		</lib-tag>
	</div>
	}
</div>
} } }
